import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { m as marginPropTypes } from './spacing-7e57ffb0.js';
import { S as SvgIcon } from './SvgIcon-1308e965.js';

function IconInstagram(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.667 2A2.67 2.67 0 0 0 2 4.667v6.667a2.67 2.67 0 0 0 2.667 2.667h6.667a2.67 2.67 0 0 0 2.667-2.667V4.667A2.67 2.67 0 0 0 11.334 2H4.667zm6.666 13.333H4.666c-2.206 0-4-1.794-4-4V4.666c0-2.206 1.794-4 4-4h6.667c2.206 0 4 1.794 4 4v6.667c0 2.206-1.794 4-4 4zM8.029 5.971a2.001 2.001 0 0 0-1.978 2.293 2 2 0 1 0 1.978-2.293zm-.007 5.333c-.71 0-1.398-.225-1.979-.656A3.31 3.31 0 0 1 4.732 8.46a3.339 3.339 0 0 1 3.786-3.787 3.316 3.316 0 0 1 2.809 2.809c.131.881-.09 1.76-.62 2.475a3.309 3.309 0 0 1-2.685 1.347zM11.667 5a.7.7 0 0 1-.473-.193.767.767 0 0 1-.14-.22.56.56 0 0 1-.053-.253.7.7 0 0 1 .193-.473c.253-.247.7-.247.947 0 .12.127.193.3.193.473 0 .087-.02.173-.053.253s-.08.153-.14.22a.701.701 0 0 1-.473.193z"
  }));
}
IconInstagram.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconInstagram.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconInstagram as default };
